/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { AI_METADATA_BATCH } from '@/configs/strings/ai-metadata-batches.strings'
import { AI_METADATA } from '@/configs/strings/ai-metadata.strings'
import { defaultToastConfig } from '@/configs/toast'
import { aiMetadataBatchesUrls } from '@/configs/urls'
import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const RetryModal = ({
  aiMetadata,
  batchId,
  batchName,
  getAccessToken,
  onClose,
  onRetry,
  retryBatch,
  toast
}) => {
  const navigate = useNavigate()
  const handleContinue = () => {
    const itemType = retryBatch
      ? AI_METADATA_BATCH
      : AI_METADATA
    try {
      const retryParams = { batchId }

      !retryBatch && (retryParams.itemId = aiMetadata.id)
      onRetry && onRetry(retryParams, getAccessToken)

      toast({
        title: itemType,
        description: `The ${itemType} '${batchName}' is being processed; we will notify you when it is finished.`,
        status: 'success',
        ...defaultToastConfig
      })
    } catch (error) {
      toast({
        title: `Error on ${itemType}`,
        description: error.response?.data?.message ||
          `Failed processing the ${itemType}. Please contact with us.`,
        status: 'error',
        ...defaultToastConfig
      })
    } finally {
      navigate(`/${aiMetadataBatchesUrls.base}`)
    }
  }
  const textBody = retryBatch
    ? `The ${AI_METADATA_BATCH}: "${batchName}" will be retried. We will notify you whe it's done.`
    : `The process of creating the ${AI_METADATA}:  "${aiMetadata?.title}"  will be retried. We will notify you whe it's done.`
  const title = retryBatch
    ? `Retry ${AI_METADATA_BATCH}`
    : `Retry ${AI_METADATA}`

  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{ title }</ModalHeader>
        <ModalCloseButton onClick={onClose} />
        <ModalBody>
          <div className="mb-4">
            { textBody }
          </div>
          <ButtonGroup gap='4'>
            <Button
              colorScheme="gray"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button onClick={handleContinue}>
              Continue
            </Button>
          </ButtonGroup>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default RetryModal
